export default __webpack_public_path__ + "static/Haya-95e63e24c1781b47f789a949655539e7.webp";